import { objectByString } from "@/pages/product_card/tools/object";

export const getColors = function (state) {
  let data = {};
  Object.entries(state.products).forEach(([, product]) => {
    if (product?.color?.id !== undefined) {
      data[objectByString(product, "id")] = product.color;
    }
  });

  return data;
};

export const isShowSizeMap = function (state) {
  let sizeMap = objectByString(state.getSelectedProduct, "sizeMap.rows");
  return sizeMap !== undefined && Object.keys(sizeMap).length > 0;
};

export const isActiveColor = function (productId, product) {
  if (product === undefined) {
    return false;
  }
  return Number(objectByString(product, "id")) === Number(productId);
};

export const isActiveSize = function (sizeId, offer) {
  if (offer === undefined) {
    return false;
  }
  return Number(objectByString(offer, "size.id")) === Number(sizeId);
};
